/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * video-service.ts  2026-01-21T16:22:03+08:00
 */
import type { R, RpcService, MethodConfig as M, PagedList } from 'krpc-base'

import type { PlayAction, TopQuery, SlidePage, Feed } from './wy-dto'

const _ = 'Video/'

export class VideoService {
  constructor(readonly r: RpcService) {}
  // 不想看/减少推荐
  block(d: number, m?: M): R<boolean> {
    return this.r.async(_ + 'block', d, m)
  }
  // 一键清理无效的收藏视频，返回清理个数，仅供参考
  cleanInvalidLike(m?: M): R<number> {
    return this.r.async(_ + 'cleanInvalidLike', undefined, m)
  }
  // 关注的人的视频，时间倒序，看过也在
  following(d: TopQuery, m?: M): R<Array<Feed>> {
    return this.r.async(_ + 'following', d, m)
  }
  // 根据视频id批量获取播放信息 目前使用：1. 我的足迹
  getByVideoIds(d: Array<number>, m?: M): R<Array<Feed>> {
    return this.r.async(_ + 'getByVideoIds', d, m)
  }
  // 是否关注
  hasFollowed(d: string, m?: M): R<boolean> {
    return this.r.async(_ + 'hasFollowed', d, m)
  }
  // 是否点赞过某个视频
  hasLiked(d: number, m?: M): R<boolean> {
    return this.r.async(_ + 'hasLiked', d, m)
  }
  // 点赞某个视频
  like(d: number, m?: M): R<boolean> {
    return this.r.async(_ + 'like', d, m)
  }
  // 我点赞的视频,视频下线的话，Feed中的video字段，只返回id（用于取消收藏），其余字段为null
  liked(d: SlidePage, m?: M): R<PagedList<Feed>> {
    return this.r.async(_ + 'liked', d, m)
  }
  // 播放事件上报，没有统一埋点，暂时这里单独处理;固定返回0
  track(d: PlayAction, m?: M): R<number> {
    return this.r.async(_ + 'track', d, m)
  }
  // 分享事件上报;固定返回0
  trackShare(d: number, m?: M): R<number> {
    return this.r.async(_ + 'trackShare', d, m)
  }
  // 取消点赞某个视频
  unlike(d: number, m?: M): R<boolean> {
    return this.r.async(_ + 'unlike', d, m)
  }
}
